function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
export var EXECUTE_BILL_RUN_CONSTANTS = {
  BEGIN: 'EXECUTE_BILL_RUN_BEGIN',
  SUCCESS: 'EXECUTE_BILL_RUN_SUCCESS',
  FAILURE: 'EXECUTE_BILL_RUN_FAILURE'
};
var EXECUTE_BILL_RUN_EVENTS = [EXECUTE_BILL_RUN_CONSTANTS.BEGIN, EXECUTE_BILL_RUN_CONSTANTS.SUCCESS, EXECUTE_BILL_RUN_CONSTANTS.FAILURE];
export var executeBillRunPromise = function executeBillRunPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, EXECUTE_BILL_RUN_EVENTS, {
    method: 'post',
    url: 'LineOfBusiness/ExecuteConvergentBillerBillRun',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {}
  });
};
export var executeBillRun = function executeBillRun(customerId) {
  return function (dispatch) {
    return executeBillRunPromise(dispatch, customerId);
  };
};
export var COMPLETE_WORKFLOW_STATUS = {
  BEGIN: 'COMPLETE_WORKFLOW_BEGIN',
  SUCCESS: 'COMPLETE_WORKFLOW_SUCCESS',
  FAILURE: 'COMPLETE_WORKFLOW_FAILURE'
};
var COMPLETE_WORKFLOW_EVENTS = [COMPLETE_WORKFLOW_STATUS.BEGIN, COMPLETE_WORKFLOW_STATUS.SUCCESS, COMPLETE_WORKFLOW_STATUS.FAILURE];
export var completeWorkflowPromise = function completeWorkflowPromise(dispatch, customerId, workflowId) {
  return ThunkHelper(dispatch, COMPLETE_WORKFLOW_EVENTS, {
    method: 'post',
    url: 'Workflow/UpdateWorkflowStatus',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      ActivityId: workflowId
    }
  });
};
export var completeWorkflow = function completeWorkflow(customerId, workflowId) {
  return function (dispatch) {
    return completeWorkflowPromise(dispatch, customerId, workflowId);
  };
};
export var RETRIEVE_ACTIVE_WORKFLOWS_STATUS = {
  BEGIN: 'RETRIEVE_ACTIVE_WORKFLOWS_BEGIN',
  SUCCESS: 'RETRIEVE_ACTIVE_WORKFLOWS_SUCCESS',
  FAILURE: 'RETRIEVE_ACTIVE_WORKFLOWS_FAILURE'
};
var RETRIEVE_ACTIVE_WORKFLOWS_EVENTS = [RETRIEVE_ACTIVE_WORKFLOWS_STATUS.BEGIN, RETRIEVE_ACTIVE_WORKFLOWS_STATUS.SUCCESS, RETRIEVE_ACTIVE_WORKFLOWS_STATUS.FAILURE];
export var retrieveActiveWorkflowsPromise = function retrieveActiveWorkflowsPromise(dispatch, customerId) {
  return ThunkHelper(dispatch, RETRIEVE_ACTIVE_WORKFLOWS_EVENTS, {
    method: 'post',
    url: 'Workflow/SearchActiveActivities',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      SearchTags: [{
        'Key': 1,
        'Value': customerId.toString()
      }],
      PageSize: 25,
      State: 7 //enum: ActivityStateType.InProcess
    }
  });
};
export var retrieveActiveWorkflows = function retrieveActiveWorkflows(customerId) {
  return function (dispatch) {
    return retrieveActiveWorkflowsPromise(dispatch, customerId);
  };
};
export var SUBMIT_USAGE_STATUS = {
  BEGIN: 'SUBMIT_USAGE_BEGIN',
  SUCCESS: 'SUBMIT_USAGE_SUCCESS',
  FAILURE: 'SUBMIT_USAGE_FAILURE'
};
var SUBMIT_USAGE_EVENTS = [SUBMIT_USAGE_STATUS.BEGIN, SUBMIT_USAGE_STATUS.SUCCESS, SUBMIT_USAGE_STATUS.FAILURE];
export var createSubmitUsagePromise = function createSubmitUsagePromise(dispatch) {
  var usage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return ThunkHelper(dispatch, SUBMIT_USAGE_EVENTS, {
    method: 'post',
    url: 'LineOfBusiness/SimulateUsage',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, usage.SubscriberId),
    data: {
      EventSource: usage.EventSource,
      NetworkEventTypeCode: usage.SelectedNetworkEvent,
      NetworkEventSubTypeCode: usage.SelectedNetworkEventSubType,
      Quantity: usage.Quantity,
      ServiceIdentifier: usage.SelectedServiceIdentifier,
      UnitOfMeasureCode: usage.SelectedUnitOfMeasureCode
    }
  });
};
export var submitUsage = function submitUsage(usage) {
  return function (dispatch) {
    return createSubmitUsagePromise(dispatch, usage);
  };
};